<div role="tooltip" class="toolTip formfield__toolTip"
     (mouseleave)="setTooltipVisibility(false)"
     (mouseenter)="setTooltipVisibility(true)"
     tabindex="-1">

    <span *ngIf="show" class="toolTip__container" [ngClass]="{ 'toolTip--show': show }">
          <span class="toolTip__body">
            {{ translateKey | translate }}
        </span>
    </span>

</div>
